// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2y76U","containerItemsCenter":"Skeleton_containerItemsCenter__2XtfE"};